import { render, staticRenderFns } from "./campDetailPlanModuleItem.vue?vue&type=template&id=6d996a54&scoped=true&"
import script from "./campDetailPlanModuleItem.vue?vue&type=script&lang=js&"
export * from "./campDetailPlanModuleItem.vue?vue&type=script&lang=js&"
import style0 from "./campDetailPlanModuleItem.vue?vue&type=style&index=0&id=6d996a54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d996a54",
  null
  
)

export default component.exports